<template>
  <v-dialog v-model="dialog" persistent max-width="350">
    <template v-slot:activator="{ on }">
      <!-- <v-btn color="primary" dark v-on="on">Open Dialog</v-btn> -->
      <v-btn icon v-on="on" dark>
        <v-icon>mdi-account-multiple-check</v-icon>
      </v-btn>
    </template>
    <v-card>
      <v-card-title primary-title>
        Add Group
        <v-spacer></v-spacer>
        <v-btn :loading="loadingBtn" @click="close" icon>
          <v-icon>mdi-window-close</v-icon>
        </v-btn>
      </v-card-title>
      <v-card-text>
        <!-- <div>{{ SortedLinks }}</div> -->
        <!-- <div>{{ values }}</div> -->
        <p v-html="message" class="red--text"></p>
        <p v-html="ErrMessage" class="red--text"></p>
        <v-form ref="GrouForm">
          <v-text-field
            name="Groupname"
            v-model="GroupName"
            :rules="[v => !!v || 'Group Name is required']"
            label="Group Name"
            id="Groupid"
          ></v-text-field>
          <v-treeview
            ref="tree"
            v-model="values"
            open-on-click
            selectable
            :items="GroupGetters"
            item-text="text"
            item-children="child"
            item-key="text"
          ></v-treeview>
        </v-form>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn :loading="loadingBtn" block @click="AddGoup" color="success"
          >Save Group</v-btn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import { mapGetters } from "vuex";
// import _ from "lodash";
export default {
  props: { AtFinshed: { type: Function } },
  data: () => ({
    dialog: false,
    values: [],
    GroupName: "",
    links: [],
    message: "",
    loadingBtn: false,
    ErrMessage: "",
  }),
  watch: {
    values() {
      this.message = "";
    },
    GroupName() {
      this.ErrMessage = "";
    },
  },
  computed: {
    ...mapGetters(["GroupGetters"]),
  },
  methods: {
    close() {
      this.dialog = false;
      this.values = [];
      this.$refs.GrouForm.reset();
    },
    AddGoup() {
      this.ErrMessage = "";
      if (this.$refs.GrouForm.validate()) {
        this.message = "";
        if (this.values.length === 0) {
          this.message = `please select Access path of  <span class="black--text">${this.GroupName}</span> `;
          return;
        }
        this.loadingBtn = true;
        this.$store
          .dispatch("INSERT_ONLY", {
            url: "/users/groups",
            data: { GroupName: this.GroupName, route: this.values },
          })
          .then(() => {
            // console.log(result);
            // this.values = [];
            // this.$refs.GrouForm.reset();
            this.AtFinshed();
            this.close();
            this.loadingBtn = false;
          })
          .catch(error => {
            // console.log(error.response);
            if (error.response) this.ErrMessage = error.response.data;
            this.loadingBtn = false;
          });
        this.message = "";
      }
    },
  },
};
</script>
